"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_json_view_1 = tslib_1.__importDefault(require("react-json-view"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../../comps/reusables");
const graphql_1 = require("../../../../../graphql");
const react_2 = require("@osmosys/react");
class EspAdapterRequest extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            caughtError: '',
            caughtErrorInfo: '',
            showInspector: false,
        };
    }
    componentDidCatch(caughtError, caughtErrorInfo) {
        this.setState({
            caughtError,
            caughtErrorInfo,
        });
    }
    render() {
        const _a = this.props, { integration, fn, children } = _a, props = tslib_1.__rest(_a, ["integration", "fn", "children"]);
        const { caughtError, showInspector } = this.state;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(react_components_1.Query, Object.assign({ query: graphql_1.espAdapterRequest }, props, { variables: Object.assign({ data: this.props.variables && this.props.variables.data
                        ? JSON.stringify(this.props.variables.data)
                        : undefined, fn, id: integration.id }, this.props.variables), notifyOnNetworkStatusChange: true }), ({ data, loading, error }) => {
                if (!data || loading) {
                    return react_1.default.createElement(reusables_1.Loading, { useContainer: true });
                }
                if (error) {
                    return (react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "Salesforce", action: "read", apolloError: error }));
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    caughtError ? (react_1.default.createElement(reactstrap_1.Alert, { color: "danger" }, "Error")) : (children(data.espAdapterRequest)),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(reactstrap_1.Button, { className: "my-2", onClick: () => {
                            this.setState({
                                showInspector: !showInspector,
                            });
                        } }, showInspector ? 'Hide data' : 'Show data'),
                    react_1.default.createElement("br", null),
                    showInspector && (react_1.default.createElement("div", { className: "w-100 border rounded p-2 bg-white text-left", style: { height: 450, overflowY: 'auto' } },
                        react_1.default.createElement(react_json_view_1.default, { collapseStringsAfterLength: 200, src: data.espAdapterRequest })))));
            })));
    }
}
exports.EspAdapterRequest = EspAdapterRequest;
//# sourceMappingURL=EspAdapterRequest.js.map